export default __webpack_public_path__ + "buysearchsell/images/logo-news-concierge.svg";